<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="10">
        <v-row>
          <v-col cols="12" md="4">
            <DateIOSPicker label="Ngày" :date.sync="time" outlined :rules="[$rules.date, $rules.dateFromNow]" dense />
          </v-col>
          <v-col cols="12" md="4">
            <AutocompleteDriver v-model="driver" return-object item-text="title" item-value="id" label="Lái xe" dense
              outlined auto-select-first />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field hide-details v-model="phone" label="Số điện thoại" placeholder="Nhập số điện thoại" outlined
              dense></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4" v-bind="$attrs" class="pt-0">
            <v-select v-model="busSchedule" :items="busSchedules" item-text="name" item-value="id" dense outlined
              label="Chiều di chuyển" clearable hide-details />
          </v-col>
          <v-col cols="12" md="4" class="pt-0">
            <v-select v-model="status" :items="busAttendanceStatus" item-text="title" item-value="value" dense outlined
              label="Trạng thái" clearable hide-details />
          </v-col>
          <v-col cols="12" md="4" class="pt-0">
            <v-text-field hide-details v-model="name" label="Tên tuyến" placeholder="Nhập tên tuyến" outlined
              dense></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="2">
        <v-btn height="40" color="#0D47A1" outlined @click="find">
          Tìm kiếm
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import AutocompleteDriver from '@/components/basic/input/AutocompleteDriver.vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
import moment from 'moment'

export default {
  components: { DateIOSPicker, AutocompleteDriver },
  data() {
    return {
      name: '',
      status: '',
      phone: '',
      time: moment().toISOString(),
      busSchedule: '',
      busAttendanceStatus: [
        { title: 'Đang di chuyển', value: 'running' },
        { title: 'Đã đón học sinh', value: 'pickedup' },
        { title: 'Hoàn thành', value: 'finished' }
      ],
      driver: null,
    }
  },
  computed: {
    ...mapState('BusCheckin', ['busSchedules', 'itemsPerPage', 'busCheckins']),

  },
  async created() {
  },
  methods: {
    ...mapActions('BusCheckin', ['fetchBusTracking']),
    ...mapMutations('BusCheckin', ['setBusTracking']),
    ...mapActions({
      getBusSchedule: 'BusCheckin/getBusSchedule',
    }),
    find() {
      this.getBusTrackingByPagination(1, this.itemsPerPage)
    },
    async getBusTrackingByPagination(page, itemsPerPage) {
      let specificDate = moment.utc(this.time)
      let nextDay = specificDate.clone().add(1, 'days').toISOString()
      if (!itemsPerPage) itemsPerPage = this.itemsPerPage
      let params = {
        _start: (page - 1) * itemsPerPage,
        _limit: itemsPerPage,
        _sort: 'nameToNumber:ASC',
        'bus.name_contains': this.name,
        'bus.phone_contains': this.phone,
        'status': this.status,
        'bus.driver': this.driver && this.driver.id,
        'bus_schedule': this.busSchedule,
        'createdAt_gt': this.time,
        'createdAt_lt': nextDay
      }
      await this.fetchBusTracking(params)
    }
  }
}
</script>

<style>

</style>
